export enum UserAccountMFA {
  UNSET = 0,
  DISABLED = 1,
  ENABLED = 2,
}
